import { FC, useEffect, useState } from 'react';

import { Layer, Modal, useBreakpoint } from '@hh.ru/magritte-ui';

import styles from 'components/common/BannerVideo/BannerVideoModal/BannerVideoModal.module.less';

interface BannerModalVideoProps {
    visible: boolean;
    onClose: () => void;
    videoUrl: string;
    thumbnailUrl: string;
    height: number;
    width: number;
}

const enum ModalSizes {
    Small = 'small',
    Medium = 'medium',
    Large = 'large',
}

const modalWidthMap = {
    [ModalSizes.Small]: 460,
    [ModalSizes.Medium]: 600,
    [ModalSizes.Large]: 800,
};

const enum VideoSizes {
    Small = 480,
    Large = 720,
}

export const BannerVideoModal: FC<BannerModalVideoProps> = ({
    visible,
    onClose,
    videoUrl,
    thumbnailUrl,
    height,
    width,
}) => {
    const [modalSize, setModalSize] = useState<ModalSizes>(ModalSizes.Large);
    const [videoHeight, setVideoHeight] = useState(0);

    const aspectRatio = width / height;

    const { isMobile } = useBreakpoint();

    useEffect(() => {
        const updateVideoHeight = () => {
            const dependentHeight = window.innerHeight * 0.7;
            const proportionalHeight = modalWidthMap[modalSize] / aspectRatio;
            setVideoHeight(Math.min(dependentHeight, proportionalHeight));
        };

        updateVideoHeight();

        window.addEventListener('resize', updateVideoHeight);

        return () => {
            window.removeEventListener('resize', updateVideoHeight);
        };
    }, [aspectRatio, modalSize]);

    useEffect(() => {
        if (height > width || height <= VideoSizes.Small) {
            setModalSize(ModalSizes.Small);
        } else if (height <= VideoSizes.Large) {
            setModalSize(ModalSizes.Medium);
        }
    }, [height, width]);

    // Запрещаем скролл при открытом видео на моб экране
    useEffect(() => {
        if (isMobile && visible) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }

        return () => {
            document.body.style.overflow = '';
        };
    }, [isMobile, visible]);

    const content = (
        <div className={styles.bannerVideoModal} onClick={(e) => e.stopPropagation()}>
            <video
                height={videoHeight}
                className={styles.bannerVideoModalPlayer}
                controls
                src={videoUrl}
                poster={thumbnailUrl}
            />
        </div>
    );

    return (
        <>
            {isMobile ? (
                <>
                    {visible && (
                        <Layer layer="modal">
                            <div onClick={onClose} className={styles.bannerVideoMobileContainer}>
                                {content}
                            </div>
                        </Layer>
                    )}
                </>
            ) : (
                <Modal
                    visible={visible}
                    onClose={onClose}
                    size={modalSize}
                    disableHorizontalPaddings
                    disableVerticalPaddings
                >
                    {content}
                </Modal>
            )}
        </>
    );
};
